export default __webpack_public_path__ + "static/rfq-created-35db4e51727c58bade0d2790a8d8c3c6.png";